import FaqAccordion from "./accoedion";

const Faq = ({faq_data}) => {
  return (
    <div>
      {/* <!-- FAQ --> */}
      <section className="relative py-24 dark:bg-jacarta-800">
        <div className="container">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="lg:w-[100%]">
              <h2 className="mb-6 font-display text-3xl font-medium text-jacarta-700 dark:text-white">
                Frequently Asked Questions
              </h2>

              <FaqAccordion faq_data={faq_data}/>

              <p className="text-lg text-jacarta-700 dark:text-jacarta-100">
                Any Question?{" "}
                <a href="mailto:hello@engineeringbookclub.com" className="text-accent">
                  hello@engineeringbookclub.com
                </a>
              </p>
            </div>

          </div>
        </div>
      </section>
      {/* <!-- end faq --> */}
    </div>
  );
};

export default Faq;
